import * as React from 'react';
import { UIHeading2, UIText2 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ModalHeader(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx(UIHeading2, {
      children: title
    }), /*#__PURE__*/_jsx(UIText2, {
      children: subtitle
    })]
  });
}